import { render, staticRenderFns } from "./Workstations.vue?vue&type=template&id=6eeb453b&scoped=true"
import script from "./Workstations.vue?vue&type=script&lang=js"
export * from "./Workstations.vue?vue&type=script&lang=js"
import style0 from "./Workstations.vue?vue&type=style&index=0&id=6eeb453b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeb453b",
  null
  
)

export default component.exports